import React from 'react'
import { useAtomValue } from 'jotai'
import { userAtom } from '../../store/userAtoms'
import { isAdminOrPartner } from '../../utils/roleGuard'
import { PartnerLayout } from '../PartnerLayout'
import { useTar } from '@/modules/i18n'

interface PartnerRouteGuardProps {
  children: React.ReactNode
}

export const PartnerRouteGuard: React.FC<PartnerRouteGuardProps> = ({ children }) => {
  const user = useAtomValue(userAtom)
  const { t } = useTar()

  if (!user) {
    return (
      <div className="flex items-center justify-center w-full">
        <div className="space-y-8">
          <div className="text-center">
            <h2 className="mt-6 text-3xl font-extrabold text-foreground">
              {t('partner.authenticationRequired')}
            </h2>
            <p className="mt-2 text-sm text-muted-foreground">
              {t('partner.pleaseSignIn')}
            </p>
          </div>
        </div>
      </div>
    )
  }

  if (!isAdminOrPartner(user)) {
    return (
      <div className="flex items-center justify-center w-full">
        <div className="space-y-8">
          <div className="text-center">
            <h2 className="mt-6 text-3xl font-extrabold text-error">
              {t('partner.accessDenied')}
            </h2>
            <p className="mt-2 text-sm text-muted-foreground">
              {t('partner.accessDeniedDescription')}
            </p>
            <p className="mt-1 text-xs text-muted">
              {t('partner.partnerRoleRequired')}
            </p>
          </div>
        </div>
      </div>
    )
  }

  return <PartnerLayout>{children}</PartnerLayout>
}
